export const N11 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "advancedGauge",
        "colorTheme": 'colorTheme1',
        "title": "CALL REACH",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "title": "Title",
                "value": 'Progress',
                "total": 'Total',
                "endpoint": "N11",
                "parameters": [
                    { key: "FromMonth", value: "CP1" },
                    { key: "FromYear", value: "2026" },
                    { key: "ToMonth", value: "CP1" },
                    { key: "ToYear", value: "2026" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}